export default
[
  {
    "day": "Upper A",
    "image": "/assets/exercise-photos/upper-a.jpg",
    "exercises": [
      "warmup",
      "barbell-bench-press",
      "barbell-bent-over-row",
      "dumbbell-shoulder-press",
      "wide-grip-lateral-pulldown",
      "cable-crossover",
      "reverse-dumbbell-fly",
      "overhead-tricep-extension",
      "dumbbell-curl",
    ]
  },
  {
    "day": "Lower A",
    "image": "/assets/exercise-photos/legs.jpg",
    "exercises": [
      "warmup",
      "back-squat",
      "dumbbell-lunge",
      "leg-curl",
      "leg-extension",
      "calf-raise",
      "hanging-leg-raise",
      "plank",
      "bicycle-crunch"
    ]
  },
  {
    "day": "Upper B",
    "image": "/assets/exercise-photos/back.jpg",
    "exercises": [
      "warmup",
      "wide-grip-pullup",
      "incline-dumbbell-bench-press",
      "cable-tricep-pressdown",
      "standard-pushup",
      "dumbbell-curl",
      "tricep-kickback",
      "dumbbell-lateral-raise"
    ]
  },
  {
    "day": "Lower B",
    "image": "/assets/exercise-photos/legs2.jpg",
    "exercises": [
      "warmup",
      "leg-press-machine",
      "romanian-deadlift",
      "dumbbell-shrug",
      "calf-raise",
      "hanging-leg-raise",
      "plank",
      "bicycle-crunch"
    ]
  },
]



//////////////////
// WEBPACK FOOTER
// ./src/providers/plan/stephen-plan-2023.js
// module id = 255
// module chunks = 6